import {
  GET_USER_SMART_VIEWS,
  GET_USER_SMART_VIEWS_SUCCESS,
  GET_USER_SMART_VIEWS_ERROR,
  CREATE_USER_SMART_VIEWS,
  CREATE_USER_SMART_VIEWS_SUCCESS,
  CREATE_USER_SMART_VIEWS_ERROR,
  UPDATE_USER_SMART_VIEWS,
  UPDATE_USER_SMART_VIEWS_SUCCESS,
  UPDATE_USER_SMART_VIEWS_ERROR,
  DELETE_USER_SMART_VIEWS,
  DELETE_USER_SMART_VIEWS_SUCCESS,
  DELETE_USER_SMART_VIEWS_ERROR,
  RESET_LAST_USER_SMART_VIEW_ACTION
} from "./actionTypes"

const initialState = {
  error: null,
  user_smart_views: [],
  loading: false,
  update_smart_view_loading: false,
  create_smart_view_loading: false,
  lastUserSmartViewAction: null,
  lastUserSmartViewId: null
}

const UserSmartViews = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_SMART_VIEWS:
      return {
        ...state,
        loading: true
      }

    case GET_USER_SMART_VIEWS_SUCCESS:
      return {
        ...state,
        user_smart_views: action.payload,
        loading: false
      }

    case GET_USER_SMART_VIEWS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case CREATE_USER_SMART_VIEWS:
      return {
        ...state,
        loading: true,
        create_smart_view_loading: true,
      }

    case CREATE_USER_SMART_VIEWS_SUCCESS:
      return {
        ...state,
        user_smart_views: [...state.user_smart_views, ...action.payload],
        loading: false,
        create_smart_view_loading: false,
        lastUserSmartViewAction: action.payload?.[0]?.id ? action.type : state.lastUserSmartViewAction,
        lastUserSmartViewId: action.payload?.[0]?.id
      }

    case CREATE_USER_SMART_VIEWS_ERROR:
      return {
        ...state,
        error: action.payload,
        create_smart_view_loading: false,
        loading: false
      }

    case UPDATE_USER_SMART_VIEWS:
      return {
        ...state,
        loading: true,
        update_smart_view_loading: true,
      }

    case UPDATE_USER_SMART_VIEWS_SUCCESS:
      return {
        ...state,
        user_smart_views: state.user_smart_views.map(user_sm_view => {
          const same_view_in_payload = action.payload.find(payload_user_sm_view => payload_user_sm_view.id === user_sm_view.id);
          if (same_view_in_payload) {
            return same_view_in_payload;
          }

          return user_sm_view;
        }),
        update_smart_view_loading: false,
        loading: false,
        lastUserSmartViewAction: action.payload?.[0]?.id ? action.type : state.lastUserSmartViewAction,
        lastUserSmartViewId: action.payload?.[0]?.id
      }

    case UPDATE_USER_SMART_VIEWS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        update_smart_view_loading: false,
      }

    case DELETE_USER_SMART_VIEWS:
      return {
        ...state,
        loading: true
      }

    case DELETE_USER_SMART_VIEWS_SUCCESS:
      return {
        ...state,
        user_smart_views: state.user_smart_views.filter(user_sm_view => {
          return !action.payload.find(payload_user_sm_view => payload_user_sm_view.id === user_sm_view.id)
        }),
        loading: false,
        lastUserSmartViewAction: action.payload?.[0]?.id ? action.type : state.lastUserSmartViewAction,
        lastUserSmartViewId: action.payload?.[0]?.id
      }

    case DELETE_USER_SMART_VIEWS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case RESET_LAST_USER_SMART_VIEW_ACTION:
      return {
        ...state,
        lastUserSmartViewAction: null,
        lastUserSmartViewId: null
      }

    default:
      return state
  }
}

export default UserSmartViews;
